import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Search, MessageSquare, Star, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { GlassCard } from '../shared';

/**
 * QuickActions — 4 boutons rapides pour actions principales
 */
export const QuickActions = () => {
  const actions = [
    {
      icon: BookOpen,
      label: 'Lire',
      to: '/quran',
      color: 'from-emerald-500/20 to-emerald-900/20 hover:from-emerald-500/30',
    },
    {
      icon: Search,
      label: 'Chercher',
      to: '/search',
      color: 'from-blue-500/20 to-blue-900/20 hover:from-blue-500/30',
    },
    {
      icon: MessageSquare,
      label: 'Tafsir',
      to: '/hadith',
      color: 'from-amber-500/20 to-amber-900/20 hover:from-amber-500/30',
    },
    {
      icon: Star,
      label: 'Favoris',
      to: '/favorites',
      color: 'from-purple-500/20 to-purple-900/20 hover:from-purple-500/30',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3">
      {actions.map((action) => {
        const Icon = action.icon;
        return (
          <Link
            key={action.label}
            to={action.to}
            className={`bg-gradient-to-br ${action.color} rounded-lg p-4 flex flex-col items-center justify-center gap-2 transition-all hover:scale-105 active:scale-95`}
            data-testid={`quick-action-${action.label.toLowerCase()}`}
          >
            <Icon className="w-6 h-6 text-primary" />
            <span className="text-sm font-medium text-text-primary">{action.label}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default QuickActions;
